import React from 'react';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import Collapse from 'src/components/common/Collapse';
import AlertsDetails from 'src/components/ProductDetails/AlertsDetails/AlertsDetails';
import MPIList from '../MPIList';
import styles from './MPIView.module.less';

type MPIListViewProps = {
  ownerId: string;
  sourceOwnerId: string;
  sourceProductId: string;
  matchType: string;
  region: string;
  priceType: string;
};
const getAlertsDetailsHeader = (hasInsights: boolean, hasAlerts: boolean) => {
  if (hasInsights && hasAlerts) {
    return <h2>Insights/Alerts</h2>;
  }
  if (!hasInsights && hasAlerts) {
    return <h2>Alerts</h2>;
  }
  if (hasInsights && !hasAlerts) {
    return <h2 className={styles.header}>Insights</h2>;
  }
  return null;
};
const MPIView: React.FC<MPIListViewProps> = ({
  matchType,
  ownerId,
  region,
  priceType,
  sourceOwnerId,
  sourceProductId,
}) => {
  const { user } = useAppStateContext();
  const emailId = user?.userEmail ?? '';
  const isMPIVisible = user?.appPermissions['enable_mpi'];
  const isAlertDetailsVisible = user?.appPermissions['enable_alert'] || user?.appPermissions['enable_insight'];
  const hasAlerts = user?.appPermissions['enable_alert'] ?? false;
  const hasInsights = user?.appPermissions['enable_insight'] ?? false;
  if (!sourceOwnerId || !(isMPIVisible || isAlertDetailsVisible)) {
    return null;
  }
  return (
    <div className={styles.container}>
      {isMPIVisible && (
        <Collapse header={<h2>MPI / Price Position</h2>} isExpanded={true} className={styles.collapseContainerMpi}>
          <div className={styles.rowOne}>
            <MPIList
              sourceOwnerId={sourceOwnerId}
              sourceProductId={sourceProductId}
              matchType={matchType}
              ownerId={ownerId}
              priceType={priceType}
              regionId={region}
            />
          </div>
        </Collapse>
      )}

      {isAlertDetailsVisible && (
        <Collapse
          header={getAlertsDetailsHeader(hasInsights, hasAlerts)}
          isExpanded={true}
          className={styles.collapseContainer}
        >
          <div className={styles.rowTwo}>
            <AlertsDetails
              emailId={emailId}
              ownerId={ownerId}
              matchType={matchType}
              region={region}
              priceType={priceType}
              sourceOwnerId={sourceOwnerId}
              sourceProductId={sourceProductId}
            />
          </div>
        </Collapse>
      )}
    </div>
  );
};

export default MPIView;
